<template>
  <div class="demo">
    <div class="demo-header">
      <div class="demo-icon">
        <bg-logo :text="true" />
      </div>
      <h1 class="demo-header-text">Welcome to Brainpeek!</h1>
      <div class="demo-byline">
        Everything you need to get the best user experience
      </div>
    </div>
    <div class="info-holder">
      <div :key="option.name" v-for="option in options" class="info-box">
        <bg-icon class="info-icon" :name="option.icon" />
        <div class="info-title">{{ option.name }}</div>
        <div class="info-text">{{ option.text }}</div>
        <bg-button :text="option.cta" @click="option.link" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.demo {
  text-align: center;
}
.demo-header-text {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 10px;
}
.demo-byline {
  font-size: 18px;
  margin-bottom: 40px;
}
.info-holder {
  display: flex;
}
.info-box {
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-grow: 1;
}
.info-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}
.info-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.info-text {
  font-size: 20px;
  margin-bottom: 40px;
}
</style>

<script>
import BgButton from "@/components/bg-button";
import BgIcon from "@/components/bg-icon";
import BgLogo from "@/components/bg-logo";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "account",
  components: {
    BgButton,
    BgLogo,
    BgIcon,
  },
  data() {
    return {
      options: [
        {
          icon: "muscleBrain",
          name: "Learn",
          text: "Our knowledge base will show you how Brainpeek works and how you can get the best results.",
          cta: "Knowledge base",
          link: () => window.open("https://braingineers.crunch.help/"),
        },
        {
          icon: "brainrocket",
          name: "Start",
          text: "The demo reports are free to explore.  There is one for mobile, and one for desktop.",
          cta: "Get started",
          link: () => this.$router.push({ path: `/tests/` }),
        },
      ],
    };
  },
};
</script>
